import LogicaAPI from "./logicaapi";
class LinkSet extends LogicaAPI {
  linkSet(id) {
    let offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
    const params = {
      device_code: this.config.deviceCode,
      app_id: this.config.appId,
      with_total_count: true,
      from: offset,
      limit
    };
    return this.get(`/api/v1/link_sets/${id}`, {
      params
    });
  }
}
export default LinkSet;